import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillExecutedStyled } from './TrlPillExecuted.styles';

export const TrlPillExecuted = () => {
  return (
    <TrlPillContainer>
      <TrlPillExecutedStyled />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-EXECUTED" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
